<template>
  <div
    class="hover:rounded-lg hover:border hover:border-neutral-500 hover:bg-neutral-300 text-center"
  >
    <button class="w-full hover:text-neutral-1000" @click="addSchedule">
      + Voeg dienst toe
    </button>
  </div>
</template>

<script lang="ts" setup>
import {
  useAddSchedule,
  useListScheduleTypeSelectOptions,
  useBroadcast,
} from "@planbord/queries/planbord-api";
import { CreateScheduleInput } from "@planbord/shared/models";

//add schedule using addSchedule.ts
const { mutateAsync: addScheduleAsync } = useAddSchedule();
const { data: typeOptions } = useListScheduleTypeSelectOptions();
const { mutateAsync: broadcast } = useBroadcast();

async function addSchedule() {
  const startTime = getStartTime();
  const endTime = getEndTime();

  //define shiftGroupId based on cluster + scheduleGroup
  const shiftGroupId = typeOptions.value?.find(
    (p) => p.Label === props.cluster
  )?.Id;

  //try to parse shiftGroupId to int
  if (shiftGroupId) {
    const schedule: CreateScheduleInput = {
      dateTime: props.date,
      shiftGroupId: parseInt(shiftGroupId),
      shiftUname: props.shiftUname ? props.shiftUname : "",
      startTime: startTime,
      endTime: endTime,
    };

    const response = await addScheduleAsync(schedule);
    await broadcast({ messageType: "addSchedule", payload: response });
  } else {
    alert(
      "Het was is helaas niet mogelijk om een nieuwe dienst toe te voegen op deze plek."
    );
  }
}

function getStartTime() {
  if (props.scheduleGroup == "HCA 24") {
    return "08:00";
  } else if (props.scheduleGroup == "HCA DD" || props.scheduleGroup == "DD") {
    return "09:00";
  } else if (props.scheduleGroup == "HCA AD" || props.scheduleGroup == "LD") {
    return "15:00";
  } else if (props.scheduleGroup == "HCA ND" || props.scheduleGroup == "ND") {
    return "23:00";
  } else if (
    props.scheduleGroup == "LCA" ||
    props.scheduleGroup == "MCA" ||
    props.scheduleGroup == "Zorgambulance"
  ) {
    return "08:30";
  } else if (props.scheduleGroup == "LZV") {
    return "09:00";
  } else if (props.scheduleGroup == "VTA") {
    return "16:30";
  }

  return "08:00";
}

function getEndTime() {
  if (props.scheduleGroup == "HCA 24") {
    return "08:00";
  } else if (props.scheduleGroup == "HCA DD" || props.scheduleGroup == "DD") {
    return "17:00";
  } else if (props.scheduleGroup == "HCA AD" || props.scheduleGroup == "LD") {
    return "23:00";
  } else if (props.scheduleGroup == "HCA ND" || props.scheduleGroup == "ND") {
    return "07:00";
  } else if (
    props.scheduleGroup == "LCA" ||
    props.scheduleGroup == "MCA" ||
    props.scheduleGroup == "Zorgambulance"
  ) {
    return "16:30";
  } else if (props.scheduleGroup == "LZV") {
    return "17:00";
  } else if (props.scheduleGroup == "VTA") {
    return "23:00";
  }
  return "23:00";
}

const props = defineProps<{
  cluster: string;
  scheduleGroup: string;
  date: Date;
  shiftUname?: string;
}>();
</script>
